import * as trackEvent from '@/libs/utils/track_event';

export const trackGaMixin = {
  data: function() {
    return {
      category: null
    };
  },
  created() {
    this.trackEvent = trackEvent;
  },
  methods: {
    initialiseTracking(category) {
      this.category = category;
      this.trackEvent.registerCategory(category);
    },
    trackCta(label, value) {
      this.trackGaEvent('cta', label, value);
      this.trackEvent.button({ label: label });
    },
    trackInput(options) {
      this.trackEvent.input(options);
      this.trackGaEvent(`input-${options.label}`, options.value);
    },
    trackGaEvent(action, label, value) {
      if (!this.$gtag) return;

      this.$gtag.event(action, {
        event_category: this.category,
        event_label: label,
        value: value
      });
    }
  }
};
